import OnIdle from '@mindtickle/ui-shell-core/IdleUntilUrgent';
import { compose } from 'recompose';
import { useUserAuth } from '~/components/Auth';
import { useVisibilityForLegacyUrl } from '~/components/LegacyAppRouting/components/Learner';
import { withRedux } from '~/components/Redux';
import { withRelay } from '~/components/Relay';
import { withSnowPlow as withSnowplow } from '~/components/Snowplow';
import { APP_NAME } from '~/config/app.constants';
import { isEmbedRoute } from '~/utils';
import globalEnv from '~/config/env';
import IncompleteProfileModal from './components/IncompleteProfileModal';
import Layout from './components/Layout';
import Logo from './components/Logo';
import { LEARNER_HEADER_SECTIONS_COUNT } from './config/constants';
import LegacyNavigator from './components/LegacyNavigator';
import ErrorBoundaryWrapperHeader from './components/ErrorBoundary';
import KScore from './components/KScore';
import Help from './components/Help';
import Profile from './components/Profile';
import { StyledRightSectionContainer } from './styles';
import Search from './components/Search';
import Notifications from './components/Notifications';

const GlobalLearnerHeader = () => {
  const isVisible = useVisibilityForLegacyUrl(globalEnv.LEGACY_WHITELISTED_HEADER_ROUTES);

  const auth = useUserAuth();
  const {
    company: { companySettings: { isExperienceCloudEnabled = false } = {} },
  } = auth;

  if (!isVisible || isExperienceCloudEnabled) {
    return null;
  }

  return (
    <ErrorBoundaryWrapperHeader>
      {!isEmbedRoute() && (
        <OnIdle>
          <IncompleteProfileModal />
        </OnIdle>
      )}
      <OnIdle>
        <LegacyNavigator />
      </OnIdle>
      <Layout
        sectionCount={LEARNER_HEADER_SECTIONS_COUNT}
        leftSection={<Logo />}
        centerSection={<Search />}
        rightSection={
          <StyledRightSectionContainer>
            <KScore />
            <Help />
            <Notifications />
            <Profile />
          </StyledRightSectionContainer>
        }
      />
    </ErrorBoundaryWrapperHeader>
  );
};

export default compose(
  withSnowplow({
    collectorUrl: globalEnv.RXP_SVC_SNOWPLOW_INGRESS,
    namespace: APP_NAME,
  }),
  withRedux(),
  withRelay({
    enableSubscription: false,
    graphqlEndpoint: globalEnv.READINESS_GQL_API_ENDPOINT,
  })
)(GlobalLearnerHeader);
